<template>
	<v-app>


		<v-main v-if="eventos.length > 0" class="surface">

			<div class="container-fluid py-0 px-0">
				<!-- Banner -->
				<v-row>
					<v-col cols="12" class="p-0">
						<div class="container-fluid">
							<FiltroBusqueda class="filtro"
								v-if="currentRoute != '/login' && currentRoute != '/registro' && currentRoute != '/passwordReset'">
							</FiltroBusqueda>

							<picture v-show="param.opcion == item.title" v-for="item in items" :key="item.img" width="100%"
								class="cover ">

								<source media="(min-width: 2880px)" :srcset="item.img.xxl" />
								<source media="(min-width: 1920px)" :srcset="item.img.xl" />
								<source media="(min-width: 1440px)" :srcset="item.img.lg" />
								<source media="(min-width: 720px)" :srcset="item.img.md" />
								<source media="(min-width: 600px)" :srcset="item.img.sm" />
								<img :src="item.img.xs" class="responsive-img" />
								<v-row>
									<v-breadcrumbs large dark class="font-weight-medium align-items-start titulo_rutas"
										:items="migaDePan">
										<template v-slot:item="{ item }">
											<v-breadcrumbs-item :to="item.path" :disabled="item.disabled">
												{{ item.text.toUpperCase() }}
											</v-breadcrumbs-item>
										</template>
									</v-breadcrumbs>

									<!--<v-text v-if="param.opcion != null"
										class="titulo_categorias text-h3 primaryContainer--text font-weight-medium">
										{{ param.opcion }}
									</v-text>-->

								</v-row>
							</picture>
							<picture v-show="param.opcion == null || param.opcion2 === 'artista'"
								v-for="imagen in eventos[0].imagens" :key="imagen.id" width="100%" class="cover ">

								<img v-if="imagen.nombre.includes('ban_desktop')" :src="imagen.url" class="responsive-img" />

								<v-row v-if="imagen.nombre.includes('ban_desktop')">
									<v-breadcrumbs large dark class="font-weight-medium align-items-start titulo_rutas"
										:items="migaDePan">
										<template v-slot:item="{ item }">
											<v-breadcrumbs-item :to="item.path" :disabled="item.disabled">
												{{ item.text.toUpperCase() }}
											</v-breadcrumbs-item>
										</template>
									</v-breadcrumbs>
									<!--<v-text v-if="param.opcion == null"
										class="titulo_categorias text-h3 primaryContainer--text font-weight-medium">
										{{ 'TODOS LOS EVENTOS' }}
									</v-text>
									<v-text v-if="param.opcion != null"
										class="titulo_categorias text-h3 primaryContainer--text font-weight-medium">
										{{ param.opcion }}
									</v-text>-->
								</v-row>
							</picture>

						</div>

					</v-col>
				</v-row>
				<!-- Resultados de Eventos  -->
				<v-container class="my-md-8 my-xl-2 order-2">
					<v-row class="space" justify-sm="center">
						<v-window min-width="90%" max-width="95%"
							class="mr-md-6 flex-md-grow-1 flex-lg-grow-0 mx-auto mx-md-0" reverse scroll-off-screen
							v-for="(evento, index) in eventos" :key="index" cols="5" xl="2" lg="3">
							<v-window-item justify="center" :key="index" v-for="(imagen, index) in evento.imagens"
								:src="imagen.url" lazy-src="@/assets/icons/logo-ticketshop-carousel.png">
								<v-col class="p-0 my-4 d-flex flex-wrap justify-content-center">
									<v-card v-if="$vuetify.breakpoint.smAndUp" fill-higth width="512" height="320" outlined
										class=" d-flex flex-row rounded-lg hover-card ">
										<v-img
											v-for=" (imagen, index) in evento.imagens.filter(img => img.nombre.includes('imagen_card_desktop'))"
											:key="index" :aspect-ratio="2 / 3" fill-height
											class="rounded-lg pa-0 ma-0 img-animation" :src="imagen.url">


										</v-img>

										<v-col width="128" max-width="320" class="d-flex flex-column wrap ml-4 px-4 py-3 py-md-6">
											<v-text>
												<v-card-title
													class="onSurface--text mb-0 pa-0 headline font-weight-bold text-break">
													{{ evento.nombre }}
												</v-card-title>
												<p class="onSurfaceVariant--text mb-1 subtitle-1">
													{{
														formatFecha(
															evento.fecha_evento
														)
													}}
												</p>
											</v-text>
											<v-spacer></v-spacer>
											<v-text class="mt-0 body-1">{{
												evento.tipoevento.nombre
											}}</v-text>
											<v-card-subtitle class="p-0 m-0  body-1 text--darken-4 green--text  ">
												<v-icon class="text--darken-4 green--text" fill-height
													size="12">mdi-checkbox-blank-circle</v-icon>
												<v-text text-color="green darken-4"> Disponible</v-text>
											</v-card-subtitle>
											<v-spacer></v-spacer>
											<router-link :to="{
												name: 'evento',
												params: {
													evento: evento.slug,
												},
											}">
												<v-btn class="d-flex align-self-baseline custom-btn" rounded color="primary">
													Comprar Entradas
												</v-btn>
											</router-link>
										</v-col>
									</v-card>

									<v-card v-if="$vuetify.breakpoint.xs" fill-higth max-width="320" max-height="240" outlined
										class="d-flex rounded-lg overflow-hidden hover-card flex-grow-1 ">

										<v-img :key="index"
											v-for="(imagen, index) in evento.imagens.filter(img => img.nombre.includes('imagen_card_mobile'))"
											:aspect-ratio="2 / 3" fill-height class="rounded-lg pa-0 ma-0 img-animation"
											:src="imagen.url">


										</v-img>

										<v-col width="128" max-width="320" class="d-flex flex-column wrap px-2 py-3">

											<v-text>

												<v-card-title
													class="onSurface--text mb-0 pa-0 text-body-1 font-weight-bold text-break hover-card-title">
													{{ evento.nombre }}

												</v-card-title>
												<p class="onSurfaceVariant--text mb-1 subtitle-2">
													{{
														formatFecha(
															evento.fecha_evento
														)
													}}
												</p>
											</v-text>
											<v-spacer></v-spacer>
											<v-text class="mt-0 body-2">{{
												evento.tipoevento.nombre
											}}</v-text>
											<v-card-subtitle height="16" class="p-0 m-0 success--text">
												<v-icon color="success" fill-height size="10">mdi-checkbox-blank-circle</v-icon>
												Disponible
											</v-card-subtitle>
											<v-spacer></v-spacer>
											<router-link :to="{
												name: 'evento',
												params: {
													evento: evento.slug,
												},
											}">
												<v-btn class="d-flex align-self-baseline custom-btn" max-width="128" small rounded
													color="primary">
													Comprar Entradas
												</v-btn>
											</router-link>
										</v-col>
									</v-card>
								</v-col>
							</v-window-item>
						</v-window>
					</v-row>
				</v-container>
			</div>
		</v-main>
		<div v-else class="text-center animated fadeInUp">
			<h1 style="color: #8c8c8c">
				<i class="material-icons" style="font-size: 100px">hourglass_empty</i><br />
				Upss. No se encontraron eventos...
			</h1>
		</div>
	</v-app>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { configApi } from "../../api/configApi";
import { headers } from "../../api/headers";
import FiltroBusqueda from "./FiltroBusqueda.vue";
export default {
	components: {
		FiltroBusqueda,
	},
	data() {
		return {
			firstPinter: true,
			girasinicio: [],
			giras: [],
			page: null,
			tiposEvento: null,
			fecha_inicio: null,
			fecha_fin: null,
			ciudadeseventos: null,
			filtro: null,
			opcion: null,
			param: {},
			currentRoute: window.location.pathname,
			arraytpevento: [],

			migaDePan: [
				{
					text: "Inicio",
					disabled: false,
					path: "/",
				},
				{
					text: "Eventos",
					disabled: false,
					path: "/",
				}
			],
			items: [
				{
					img: {
						xs: "/images/categorias/baloncesto_360.webp",
						sm: "/images/categorias/baloncesto_600.webp",
						md: "/images/categorias/baloncesto_720.webp",
						md2: "/images/categorias/baloncesto_1080.webp",
						lg: "/images/categorias/baloncesto_1440.webp",
						xl: "/images/categorias/baloncesto_1920.webp",
						xxl: "/images/categorias/baloncesto_2880.webp",
					},
					alt: "",
					title: "BALONCESTO",
				},
				{
					img: {
						xs: "/images/categorias/futbol_360.webp",
						sm: "/images/categorias/futbol_600.webp",
						md: "/images/categorias/futbol_720.webp",
						md2: "/images/categorias/futbol_1080.webp",
						lg: "/images/categorias/futbol_1440.webp",
						xl: "/images/categorias/futbol_1920.webp",
						xxl: "/images/categorias/futbol_2880.webp",
					},
					alt: "",
					title: "FÚTBOL",
				},
				{
					img: {
						xs: "/images/categorias/maraton_360.webp",
						sm: "/images/categorias/maraton_600.webp",
						md: "/images/categorias/maraton_720.webp",
						md2: "/images/categorias/maraton_1080.webp",
						lg: "/images/categorias/maraton_1440.webp",
						xl: "/images/categorias/maraton_1920.webp",
						xxl: "/images/categorias/maraton_2880.webp",
					},
					alt: "",
					title: "MARATÓN",
				},
				{
					img: {
						xs: "/images/categorias/concierto_360.webp",
						sm: "/images/categorias/concierto_600.webp",
						md: "/images/categorias/concierto_720.webp",
						md2: "/images/categorias/concierto_1080.webp",
						lg: "/images/categorias/concierto_1440.webp",
						xl: "/images/categorias/concierto_1920.webp",
						xxl: "/images/categorias/concierto_2880.webp",
					},
					alt: "",
					title: "CONCIERTOS",
				},
				{
					img: {
						xs: "/images/categorias/comedia_360.webp",
						sm: "/images/categorias/comedia_600.webp",
						md: "/images/categorias/comedia_720.webp",
						md2: "/images/categorias/comedia_1080.webp",
						lg: "/images/categorias/comedia_1440.webp",
						xl: "/images/categorias/comedia_1920.webp",
						xxl: "/images/categorias/comedia_2880.webp",
					},
					alt: "",
					title: "COMEDIA",
				},
				{
					img: {
						xs: "/images/categorias/conferencias_360.webp",
						sm: "/images/categorias/conferencias_600.webp",
						md: "/images/categorias/conferencias_720.webp",
						md2: "/images/categorias/conferencias_1080.webp",
						lg: "/images/categorias/conferencias_1440.webp",
						xl: "/images/categorias/conferencias_1920.webp",
						xxl: "/images/categorias/conferencias_2880.webp",
					},
					alt: "",
					title: "CONFERENCIAS",
				},
			]
		};
	},
	async created() {
		/*document.querySelector('.banner').style.backgroundImage = "url(https://api.ticketshop.com.co/storage/imagenes/392/banner1720497431.jpeg)";*/
		const query = localStorage.getItem('searchQuery');
		this.param = JSON.parse(query);

		this.page = this.param.page;
		this.tiposEvento = this.param.tiposEvento;
		this.fecha_inicio = this.param.fecha_inicio;
		this.fecha_fin = this.param.fecha_fin;
		this.ciudadeseventos = this.param.ciudadeseventos;
		this.filtro = this.param.filtro;
		this.opcion = this.param.opcion;

		this.filterEventos();
	},
	watch: {
		$route(to, from) {
			this.currentRoute = window.location.pathname

			const query = localStorage.getItem('searchQuery');
			this.param = JSON.parse(query);
		},
	},
	computed: {
		eventos() {
			const query = localStorage.getItem('searchQuery');
			this.param = JSON.parse(query);

			return this.$store.getters["evento/listEventos"].reverse();
		},
		loading() {
			return this.$store.getters["evento/loading"];
		},
	},
	methods: {
		changePage(page) {
			this.$store.commit("evento/changePage", page);
			this.$store.dispatch("evento/listEventosStatus", {
				page: page,
				status: 1,
			});
		},
		formatFecha(fecha) {
			if (fecha != null && fecha != "") {
				return moment(fecha).format("MMMM, DD YYYY");
			} else {
				return "";
			}
		},
		filterEventos() {
			this.$store.dispatch("evento/filterEventos", {
				page: this.page,
				tiposEvento: this.tiposEvento,
				fecha_inicio: this.fecha_inicio,
				fecha_fin: this.fecha_fin,
				ciudadeseventos: this.ciudadeseventos,
				filtro: this.filtro
			});
		}
	},
};
</script>

<style>
.filtro {
	z-index: index 5;
}

.font {
	font-family: Montserrat;
}

.titulo_eventos {
	margin-top: 360px;
	margin-left: 16px;
}

.responsive-img {
	width: 100%;
	height: auto;
	object-fit: cover;
}

.cover {
	display: block;
	width: 100%;
	height: auto;
	position: relative;
}


.titulo_categorias {
	position: absolute;
	bottom: 0;
	width: 100%;
	margin-left: 24px;
	padding: 10px;

	/* Espaciado interno */
	z-index: 0;
	/* Asegura que el texto esté por encima de la imagen */
}

.titulo_rutas {
	position: absolute;
	top: 0;
	width: 100%;
	/* Fondo semitransparente para mejor legibilidad */
	margin-left: 24px;
	padding: 10px;
	/* Espaciado interno */
	z-index: 0;
	/* Asegura que el texto esté por encima de la imagen */
}


.v-btn--search {
	top: 0;
	position: absolute;
	margin: 0 0 16px 16px;
}

@media (min-width: 360px) {
	.responsive-img {
		height: 240px;
	}
}

@media (min-width: 600px) {
	.responsive-img {
		height: 320px;
	}
}

@media (min-width: 1440px) {
	.responsive-img {
		height: 528px;
	}
}

@media (min-width: 2160px) {
	.responsive-img {
		height: 528px;
	}
}
</style>
